// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"97167b0e","80":"fc0ac416","236":"6ad90242","243":"45fd867d","310":"b690eccf","411":"b7abaaab","529":"07d20a10","623":"ae857522","699":"cec5628d","700":"4f9ce3c3","715":"c4921874","774":"a584385d","892":"1db78500","931":"12f6399c"}[chunkId] + ".chunk.js";
};